module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "expertsrecommend"
  }, [_c('mt-header', {
    attrs: {
      "title": "专家推荐"
    }
  }, [_c('mt-button', {
    attrs: {
      "slot": "left",
      "icon": "back"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    },
    slot: "left"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "expertbox"
  }, [_c('h1', [_vm._v("这里都是行业内可信赖的专家")]), _vm._v(" "), _c('h6', [_vm._v("每个专家都经过人工严格审核")]), _vm._v(" "), _c('div', {
    staticClass: "expertlist"
  }, [_c('div', {
    staticClass: "listitem"
  }, [_c('img', {
    attrs: {
      "src": _vm.httpurl + _vm.datalistone.photo,
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_vm._v("\n                  " + _vm._s(_vm.nickname) + "/" + _vm._s(_vm.datalistone.position) + "\n              ")]), _vm._v(" "), _c('p', {
    staticClass: "info",
    staticStyle: {
      "-webkit-box-orient": "vertical"
    }
  }, [_vm._v(_vm._s(_vm.datalistone.aboutMe))]), _vm._v(" "), _c('div', {
    staticClass: "classifybox"
  }, _vm._l((_vm.dataoneskills), function(item, index) {
    return _c('p', {
      key: index,
      staticClass: "classify"
    }, [_vm._v(_vm._s(item))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "listitem"
  }, [_c('img', {
    attrs: {
      "src": _vm.httpurl + _vm.datalisttwo.photo,
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_vm._v("\n                  " + _vm._s(_vm.nicknametwo) + "/" + _vm._s(_vm.datalisttwo.position) + "\n              ")]), _vm._v(" "), _c('p', {
    staticClass: "info",
    staticStyle: {
      "-webkit-box-orient": "vertical"
    }
  }, [_vm._v(_vm._s(_vm.datalisttwo.aboutMe))]), _vm._v(" "), _c('div', {
    staticClass: "classifybox"
  }, _vm._l((_vm.datatwoskills), function(item, index) {
    return _c('p', {
      key: index,
      staticClass: "classify"
    }, [_vm._v(_vm._s(item))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "listitem"
  }, [_c('img', {
    attrs: {
      "src": _vm.httpurl + _vm.datalistthree.photo,
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_vm._v("\n                  " + _vm._s(_vm.nicknamethree) + "/" + _vm._s(_vm.datalistthree.position) + "\n              ")]), _vm._v(" "), _c('p', {
    staticClass: "info",
    staticStyle: {
      "-webkit-box-orient": "vertical"
    }
  }, [_vm._v(_vm._s(_vm.datalistthree.aboutMe))]), _vm._v(" "), _c('div', {
    staticClass: "classifybox"
  }, _vm._l((_vm.datathreeskills), function(item, index) {
    return _c('p', {
      key: index,
      staticClass: "classify"
    }, [_vm._v(_vm._s(item))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "listitem"
  }, [_c('img', {
    attrs: {
      "src": _vm.httpurl + _vm.datalistfour.photo,
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_vm._v("\n                  " + _vm._s(_vm.nicknamefour) + "/" + _vm._s(_vm.datalistfour.position) + "\n              ")]), _vm._v(" "), _c('p', {
    staticClass: "info",
    staticStyle: {
      "-webkit-box-orient": "vertical"
    }
  }, [_vm._v(_vm._s(_vm.datalistfour.aboutMe))]), _vm._v(" "), _c('div', {
    staticClass: "classifybox"
  }, _vm._l((_vm.datafourskills), function(item, index) {
    return _c('p', {
      key: index,
      staticClass: "classify"
    }, [_vm._v(_vm._s(item))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "listitem"
  }, [_c('img', {
    attrs: {
      "src": _vm.httpurl + _vm.datalistfive.photo,
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_vm._v("\n                  " + _vm._s(_vm.nicknamefive) + "/" + _vm._s(_vm.datalistfive.position) + "\n              ")]), _vm._v(" "), _c('p', {
    staticClass: "info",
    staticStyle: {
      "-webkit-box-orient": "vertical"
    }
  }, [_vm._v(_vm._s(_vm.datalistfive.aboutMe))]), _vm._v(" "), _c('div', {
    staticClass: "classifybox"
  }, _vm._l((_vm.datafiveskills), function(item, index) {
    return _c('p', {
      key: index,
      staticClass: "classify"
    }, [_vm._v(_vm._s(item))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "listitem"
  }, [_c('img', {
    attrs: {
      "src": _vm.httpurl + _vm.datalistsix.photo,
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_vm._v("\n                  " + _vm._s(_vm.nicknamesix) + "/" + _vm._s(_vm.datalistsix.position) + "\n              ")]), _vm._v(" "), _c('p', {
    staticClass: "info",
    staticStyle: {
      "-webkit-box-orient": "vertical"
    }
  }, [_vm._v(_vm._s(_vm.datalistsix.aboutMe))]), _vm._v(" "), _c('div', {
    staticClass: "classifybox"
  }, _vm._l((_vm.datasixskills), function(item, index) {
    return _c('p', {
      key: index,
      staticClass: "classify"
    }, [_vm._v(_vm._s(item))])
  }), 0)])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1535ed7b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/expertsrecommend.vue
// module id = 1261
// module chunks = 1